import { lazy } from 'react';

export const InstalledEquipmentList = lazy(() => import('./installed_equipment/InstalledEquipmentList'));
export const StockList = lazy(() => import('./stock/StockList'))
export const AuditLogList = lazy(() => import('./audit_log/AuditLogList'));